import { createAction } from '@reduxjs/toolkit'

export const fetchShops = createAction('shop/fetchShops')
export const fetchLocalizedShops = createAction('shop/fetchLocalizedShops')
export const updateShop = createAction('shop/updateShop')
export const updateLocalizedShop = createAction('shop/updateLocalizedShop')
export const updateShopCouponsSettings = createAction(
  'shop/updateShopCouponsSettings'
)
export const fetchShopCampaignDeals = createAction(
  'shop/fetchShopCampaignDeals'
)
export const fetchShopImageSets = createAction('shop/fetchShopImageSets')
export const fetchShopAdPackages = createAction('shop/fetchShopAdPackages')
export const fetchShopOffers = createAction('shop/fetchShopOffers')

export const createShopCampaign = createAction('shop/campaign/createCampaign')
export const updateShopCampaign = createAction('shop/campaign/updateCampaign')

export const createShopOffer = createAction('shop/offer/createOffer')
export const updateShopOffer = createAction('shop/offer/updateOffer')

export const createShopGroup = createAction('shop/group/createGroup')
export const updateShopGroup = createAction('shop/group/updateGroup')
export const deleteShopGroup = createAction('shop/group/deleteGroup')

export const createShopCategory = createAction('shop/category/createCategory')
export const updateShopCategory = createAction('shop/category/updateCategory')
export const deleteShopCategory = createAction('shop/category/deleteCategory')

export const deleteCampaign = createAction('shop/campaign/deleteCampaign')
export const deleteAdPackage = createAction('shop/adPackage/deleteAdPackage')
export const duplicateAdPackage = createAction(
  'shop/adPackage/duplicateAdPackage'
)

export const deleteShopOffer = createAction('shop/offer/deleteOffer')
export const deleteShopAllOffers = createAction('shop/offer/deleteAllOffers')
export const fetchShopPrograms = createAction('shop/fetchShopPrograms')
export const fetchUpdateTagsCount = createAction('shop/fetchUpdateTagsCount')

// SEO Descriptions
export const fetchShopSeoDescriptions = createAction(
  'shop/seoDescription/fetchSeoDescriptions'
)
export const createShopSeoDescription = createAction(
  'shop/seoDescription/createSeoDescription'
)
export const updateShopSeoDescription = createAction(
  'shop/seoDescription/updateSeoDescription'
)
export const deleteShopSeoDescription = createAction(
  'shop/seoDescription/deleteSeoDescription'
)

// Partner Offers
export const fetchPartnerOffers = createAction('shop/fetchPartnerOffers')
export const createPartnerOffer = createAction('shop/partnerOffer/create')
export const updatePartnerOffer = createAction('shop/partnerOffer/update')
export const deletePartnerOffer = createAction('shop/partnerOffer/delete')

// Conquest Ads
export const fetchConquestAds = createAction('shop/fetchConquestAds')
export const createConquestAd = createAction('shop/conquestAd/create')
export const updateConquestAd = createAction('shop/conquestAd/update')
export const deleteConquestAd = createAction('shop/conquestAd/delete')
